export default "__VITE_ASSET__DbsajIcL__"